import Timer from "../utils/Timer";
import NotificationModal from "./NotificationModal";

/**
 * This class handle modals on which is set timer and when they should fire.
 * After they fire, on their closing they refresh the page.
 */
export default class TimerModal extends NotificationModal {

  /**
   * This class compare load time with current time every minute, and if the compare function is true, it fires given function.
   *
   * @param {string} modalSelector
   * @param {Function} compareFunction
   * @param {number} compareDifference
   * @param {Function} onCloseFunction what to do on modal closing
   */
  constructor(modalSelector, compareFunction, compareDifference, onCloseFunction = TimerModal.onCloseRefresh) {
    super(modalSelector);

    this.onCloseFunction = onCloseFunction;

    this.timer = new Timer(compareFunction, compareDifference, () => {
      $(this.modalSelector).modal('show');

      if(this.modalSelector === '[data-modal-timer="midnight"]') {

        $('.modal:not('+this.modalSelector+')').each((i, e) => {
          $(e).hide();
        });
      }
    });

    this.timer.setTimerElement('[data-timer="' + $(this.modalSelector).data('modal-timer') + '"]');
  }

  /**
   * This function adds interval for user that every minute checks if current datetime is different by set difference from page load time.
   * If yes, modal given modal appears and on its closing the page is reloaded.
   */
   initModal() {
    if(this.modalExists(this.modalSelector)) {

      // On modal closing refresh page
      $(this.modalSelector).on('hide.bs.modal', this.onCloseFunction);

      this.timer.start();
    }
  }

  /**
   * This function is intended for on close function for this modal.
   * It will refresh the page.
   */
  static onCloseRefresh() {
    window.location.reload();
  }

  /**
   * This function is intended for on close function for this modal.
   * It will go to previous page.
   */
  static onCloseGoBack() {
    window.history.back();
  }
}
